export default __webpack_public_path__ + "static/media/acuminor.100a3da6.jpg";